export function getMemberProductMap(product: Product | null | undefined) {
  return product?.relationships?.memberProductMap || {};
}

export function getMemberProduct(product: Product | null | undefined, memberProductId: string) {
  return getMemberProductMap(product)[memberProductId];
}

export function getMemberProducts(product: Product | null | undefined) {
  return Object.values(getMemberProductMap(product));
}

export function getMemberProductIds(product: Product | null | undefined) {
  return product?.relationships?.memberProductIds || [];
}

export function getMemberDisplayGroupsMap(product: Product | null | undefined) {
  return product?.detail?.memberDisplayGroupsMap || {};
}
